module.exports = __webpack_public_path__ + "img/Pattern05.84f35110.png";